(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mb-deferred-video"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mb-deferred-video')) {
    customElements.define('mb-deferred-video', class extends HTMLElement {
      static get observedAttributes() { return ['data-active']; }

      connectedCallback() {
        this.video = this.querySelector('video');
        if (!this.video || this.connected) return;
        this.connected = true;
        this.visible = false;
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.update = this.updatePlayback.bind(this);
        this.check = this.checkPosition.bind(this);
        if (this.reducedMotion.matches) this.video.controls = true;
        this.reducedMotion.addEventListener('change', this.update);
        document.addEventListener('visibilitychange', this.update);
        if ('IntersectionObserver' in window) {
          this.loadObserver = new IntersectionObserver((entries) => {
            if (entries.some(entry => entry.isIntersecting) && this.hasLayout()) this.hydrate();
          }, { rootMargin: '400px 0px' });
          this.visibilityObserver = new IntersectionObserver((entries) => {
            this.visible = entries[0].isIntersecting && this.hasLayout();
            this.updatePlayback();
          });
          this.loadObserver.observe(this.video);
          this.visibilityObserver.observe(this.video);
        } else {
          window.addEventListener('scroll', this.check, { passive: true });
          window.addEventListener('resize', this.check);
          this.checkPosition();
        }
      }

      attributeChangedCallback() {
        if (this.connected) this.updatePlayback();
      }

      hasLayout() {
        const rect = this.video.getBoundingClientRect();
        return rect.width > 0 && rect.height > 0;
      }

      checkPosition() {
        const rect = this.video.getBoundingClientRect();
        const horizontal = rect.right > 0 && rect.left < window.innerWidth;
        const shown = this.hasLayout() && horizontal;
        this.visible = shown && rect.bottom > 0 && rect.top < window.innerHeight;
        if (shown && rect.bottom > -400 && rect.top < window.innerHeight + 400) this.hydrate();
        this.updatePlayback();
      }

      hydrate() {
        if (this.loaded) return;
        this.loaded = true;
        this.video.querySelectorAll('source[data-src]').forEach(source => {
          source.src = source.dataset.src;
          source.removeAttribute('data-src');
        });
        this.video.preload = 'metadata';
        this.video.load();
        this.loadObserver?.disconnect();
        this.updatePlayback();
      }

      shouldPlay() {
        const mode = this.dataset.playback;
        return this.connected && this.loaded && this.visible && this.hasLayout() &&
          !document.hidden && !this.reducedMotion.matches && !this.autoplayBlocked &&
          (mode === 'viewport' || (mode !== 'manual' && this.dataset.active === 'true'));
      }

      updatePlayback() {
        if (!this.video) return;
        if (this.reducedMotion?.matches) this.video.controls = true;
        if (!this.shouldPlay()) {
          this.video.pause();
          return;
        }
        if (!this.video.paused || this.playPending) return;
        this.playPending = true;
        Promise.resolve(this.video.play()).then(() => {
          if (!this.shouldPlay()) this.video.pause();
        }).catch(error => {
          if (error.name !== 'AbortError' && this.connected) {
            this.autoplayBlocked = true;
            this.video.controls = true;
          }
        }).finally(() => { this.playPending = false; });
      }

      disconnectedCallback() {
        this.connected = false;
        this.video?.pause();
        this.loadObserver?.disconnect();
        this.visibilityObserver?.disconnect();
        this.reducedMotion?.removeEventListener('change', this.update);
        document.removeEventListener('visibilitychange', this.update);
        window.removeEventListener('scroll', this.check);
        window.removeEventListener('resize', this.check);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mb-delivery-estimate"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mb-delivery-estimate')) {
  customElements.define('mb-delivery-estimate', class extends HTMLElement {
    connectedCallback() { this.update(); this.refresh = () => this.update(); document.addEventListener('visibilitychange', this.refresh); }
    disconnectedCallback() { document.removeEventListener('visibilitychange', this.refresh); }
    update() {
      try {
        const parts = new Intl.DateTimeFormat('en-CA', {timeZone:this.dataset.timezone || 'UTC',year:'numeric',month:'2-digit',day:'2-digit'}).formatToParts(new Date());
        const get = type => Number(parts.find(part => part.type === type).value);
        const today = new Date(Date.UTC(get('year'),get('month')-1,get('day')));
        const holidays = new Set((this.dataset.holidays || '').split(/[\s,]+/).filter(Boolean));
        const addBusinessDays = days => {
          const date = new Date(today);
          for (let n=0;n<days;) {
            date.setUTCDate(date.getUTCDate()+1);
            if (date.getUTCDay()!==0 && date.getUTCDay()!==6 && !holidays.has(date.toISOString().slice(0,10))) n++;
          }
          return date;
        };
        const processing = Math.max(0,Math.min(20,Number(this.dataset.processing)||0));
        const minimum = Math.max(1,Math.min(20,Number(this.dataset.minimum)||3));
        const maximum = Math.max(minimum,Math.min(20,Number(this.dataset.maximum)||5));
        const format = new Intl.DateTimeFormat(this.dataset.market==='us'?'en-US':'en-GB',{day:'numeric',month:'short',timeZone:'UTC'});
        const first = addBusinessDays(processing+minimum);
        const last = addBusinessDays(processing+maximum);
        const sameMonth = first.getUTCMonth()===last.getUTCMonth() && first.getUTCFullYear()===last.getUTCFullYear();
        const month = new Intl.DateTimeFormat(this.dataset.market==='us'?'en-US':'en-GB',{month:'short',timeZone:'UTC'}).format(first);
        const range = sameMonth ? (this.dataset.market==='us' ? `${month} ${first.getUTCDate()}–${last.getUTCDate()}` : `${first.getUTCDate()}–${last.getUTCDate()} ${month}`) : `${format.format(first)}–${format.format(last)}`;
        this.querySelector('[data-delivery-window]').textContent = range;
        this.hidden=false;
      } catch { this.hidden=true; }
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mb-email-offer"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mb-email-offer')) {
  customElements.define('mb-email-offer', class extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('button');
      this.error = this.querySelector('[role="status"]');
      this.formId = this.dataset.formId;
      if (!this.button || !this.error || !this.formId) return;
      this.onClick = this.openOffer.bind(this);
      this.onFormEvent = (event) => {
        if (event.detail?.formId === this.formId && event.detail.type === 'open') this.finishOpening();
      };
      this.button.addEventListener('click', this.onClick);
      window.addEventListener('klaviyoForms', this.onFormEvent);
      this.hidden = false;
    }

    disconnectedCallback() {
      this.button?.removeEventListener('click', this.onClick);
      window.removeEventListener('klaviyoForms', this.onFormEvent);
      this.cancelPending();
    }

    cancelPending() {
      clearTimeout(this.timeout);
      if (this.request && Array.isArray(window._klOnsite)) {
        const index = window._klOnsite.indexOf(this.request);
        if (index !== -1) window._klOnsite.splice(index, 1);
      }
      this.request = null;
      this.button?.removeAttribute('aria-busy');
    }

    finishOpening() {
      this.cancelPending();
      this.error.hidden = true;
    }

    openOffer() {
      if (this.request) return;
      this.error.hidden = true;
      this.button.setAttribute('aria-busy', 'true');
      const request = ['openForm', this.formId, () => {
        if (this.request === request && this.isConnected) this.finishOpening();
      }];
      this.request = request;
      this.timeout = setTimeout(() => {
        this.cancelPending();
        this.error.hidden = false;
      }, 10000);
      try {
        window._klOnsite = window._klOnsite || [];
        window._klOnsite.push(request);
      } catch (_) {
        this.cancelPending();
        this.error.hidden = false;
      }
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mb-menu-image"] && !Shopify.designMode) return;
  try {
    (() => {
    const panelSelector = '[data-hover-disclosure], [data-sliderule]';
    const imageSelector = 'noscript[data-mb-menu-image]';
    const observers = new WeakMap();

    function reveal(panel) {
      if (!panel) return;

      panel.querySelectorAll(imageSelector).forEach((fallback) => {
        if (fallback.closest(panelSelector) !== panel) return;

        const template = document.createElement('template');
        template.innerHTML = fallback.textContent;
        fallback.replaceWith(template.content);
      });
    }

    function activate(event) {
      if (!(event.target instanceof Element)) return;

      const trigger = event.target.closest('[data-hover-disclosure-toggle], [data-sliderule-open]');
      if (!trigger) return;
      if (event.type === 'pointerover' && !trigger.hasAttribute('data-hover-disclosure-toggle')) return;

      const id = trigger.getAttribute('data-hover-disclosure-toggle') || trigger.getAttribute('data-sliderule-open');
      reveal(document.getElementById(id));
    }

    function headersWithin(root) {
      const headers = Array.from(root.querySelectorAll('[data-header-wrapper]'));
      if (root instanceof Element && root.matches('[data-header-wrapper]')) headers.push(root);
      return headers;
    }

    function watchHeaders(root) {
      headersWithin(root).forEach((header) => {
        if (observers.has(header)) return;

        const observer = new MutationObserver((records) => {
          records.forEach(({target}) => {
            if (target.matches(panelSelector) && target.classList.contains('is-visible')) reveal(target);
          });
        });

        observer.observe(header, {subtree: true, attributes: true, attributeFilter: ['class']});
        observers.set(header, observer);
        header.querySelectorAll(panelSelector).forEach((panel) => {
          if (panel.classList.contains('is-visible')) reveal(panel);
        });
      });
    }

    ['pointerover', 'pointerdown', 'focusin', 'click'].forEach((type) => {
      document.addEventListener(type, activate, {capture: true, passive: true});
    });

    ['shopify:block:select', 'theme:block:select'].forEach((type) => {
      document.addEventListener(type, (event) => {
        if (event.target instanceof Element) reveal(event.target.closest(panelSelector));
      });
    });

    document.addEventListener('shopify:section:load', (event) => watchHeaders(event.target));
    document.addEventListener('shopify:section:unload', (event) => {
      headersWithin(event.target).forEach((header) => {
        observers.get(header)?.disconnect();
        observers.delete(header);
      });
    });

    watchHeaders(document);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mb-mobile-menu"] && !Shopify.designMode) return;
  try {
    (() => {
  const observers = new WeakMap();
  function reveal(drawer) {
    if (!drawer.classList.contains('is-open')) return;
    drawer.querySelectorAll('template[data-mb-menu-thumbnail]').forEach(template => {
      template.replaceWith(template.content.cloneNode(true));
    });
    drawer.querySelectorAll('template[data-mb-menu-hero]').forEach(template => {
      if (template.closest('[data-sliderule]')?.classList.contains('is-visible')) {
        template.replaceWith(template.content.cloneNode(true));
      }
    });
  }
  function setup(root) {
    const drawer = root.querySelector('#header-menu.mb-picture-menu');
    if (!drawer || observers.has(drawer)) return;
    const observer = new MutationObserver(() => reveal(drawer));
    observer.observe(drawer, {attributes: true, subtree: true, attributeFilter: ['class']});
    observers.set(drawer, observer);
    reveal(drawer);
  }
  setup(document);
  document.addEventListener('shopify:section:load', event => setup(event.target));
  document.addEventListener('shopify:section:unload', event => {
    const drawer = event.target.querySelector('#header-menu.mb-picture-menu');
    if (drawer) observers.get(drawer)?.disconnect();
  });
  document.addEventListener('shopify:block:select', event => {
    const thumbnail = event.target.closest('.mb-menu-thumbnail');
    const drawer = thumbnail?.closest('#header-menu');
    if (drawer && !drawer.classList.contains('is-open')) document.querySelector('[data-drawer-toggle="hamburger"]')?.click();
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mb-press-marquee"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mb-press-marquee')) {
  customElements.define('mb-press-marquee', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.mb-press-marquee__track');
      this.group = this.querySelector('.mb-press-marquee__group');
      if (!this.group?.children.length) return;
      this.copy = this.group.cloneNode(true);
      this.copy.setAttribute('data-copy', '');
      this.copy.setAttribute('aria-hidden', 'true');
      this.copy.inert = true;
      this.copy.removeAttribute('aria-label');
      this.copy.querySelectorAll('[id],[data-shopify-editor-block]').forEach(node => {
        node.removeAttribute('id');
        node.removeAttribute('data-shopify-editor-block');
      });
      this.track.append(this.copy);
      this.setAttribute('data-ready', '');
      this.updateDuration = () => {
        const speed = Number(this.dataset.speed) || 20;
        this.track.style.animationDuration = this.group.getBoundingClientRect().width / speed + 's';
      };
      this.resizeObserver = new ResizeObserver(this.updateDuration);
      this.resizeObserver.observe(this.group);
      this.updateDuration();
      this.visibilityObserver = new IntersectionObserver(entries => {
        this.dataset.visible = String(entries[0].isIntersecting);
      });
      this.visibilityObserver.observe(this);
    }
    disconnectedCallback() {
      this.resizeObserver?.disconnect();
      this.visibilityObserver?.disconnect();
      this.copy?.remove();
      this.removeAttribute('data-ready');
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mb-product-benefits"] && !Shopify.designMode) return;
  try {
    const watchPurchaseArea = () => {
  const area = document.querySelector('.product__content');
  if (!area || area.dataset.confidenceObserved) return;
  area.dataset.confidenceObserved='true';
  const observer = new IntersectionObserver(entries => {
    document.body.classList.toggle('mb-purchase-visible',entries.some(entry=>entry.isIntersecting));
  });
  observer.observe(area);
};
watchPurchaseArea();
document.addEventListener('shopify:section:load',watchPurchaseArea);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mb-sale-countdown"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mb-sale-countdown')) {
  customElements.define('mb-sale-countdown', class extends HTMLElement {
    connectedCallback() {
      this.frame = requestAnimationFrame(() => this.start());
    }

    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      clearInterval(this.interval);
      document.removeEventListener('visibilitychange', this.refresh);
      window.removeEventListener('pageshow', this.refresh);
    }

    resolveDeadline(value, timeZone) {
      const match = /^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2})$/.exec(value || '');
      if (!match) return NaN;
      const [year, month, day, hour, minute] = match.slice(1).map(Number);
      if (year < 2000 || year > 9999 || month < 1 || month > 12 || day < 1 || day > 31 || hour > 23 || minute > 59) return NaN;
      const wall = Date.UTC(year, month - 1, day, hour, minute);
      if (new Date(wall).getUTCDate() !== day) return NaN;
      const formatter = new Intl.DateTimeFormat('en-GB', {
        timeZone, year:'numeric', month:'2-digit', day:'2-digit',
        hour:'2-digit', minute:'2-digit', second:'2-digit', hourCycle:'h23'
      });
      const wallAt = stamp => {
        const parts = Object.fromEntries(formatter.formatToParts(stamp).map(part => [part.type, part.value]));
        return Date.UTC(Number(parts.year), Number(parts.month) - 1, Number(parts.day), Number(parts.hour), Number(parts.minute), Number(parts.second));
      };
      const offsets = new Set([-36, 0, 36].map(hours => {
        const sample = wall + hours * 3600000;
        return wallAt(sample) - sample;
      }));
      const candidates = [...offsets].map(offset => wall - offset).filter(stamp => wallAt(stamp) === wall);
      return candidates.length ? Math.min(...candidates) : NaN;
    }

    start() {
      this.hidden = true;
      clearInterval(this.interval);
      this.units = [...this.querySelectorAll('[data-sale-unit]')];
      const ends = this.querySelector('.mb-sale-countdown__ends');
      if (this.units.length !== 4 || !ends || !this.dataset.saleName?.trim() || !this.dataset.timezone) return;
      try {
        this.deadline = this.resolveDeadline(this.dataset.end, this.dataset.timezone);
        if (!Number.isFinite(this.deadline)) return;
        const locale = document.documentElement.lang || 'en';
        const weekday = new Intl.DateTimeFormat(locale, { timeZone:this.dataset.timezone, weekday:'long' }).format(this.deadline);
        const full = new Intl.DateTimeFormat(locale, {
          timeZone:this.dataset.timezone, weekday:'long', year:'numeric', month:'long', day:'numeric',
          hour:'numeric', minute:'2-digit', timeZoneName:'long'
        }).format(this.deadline);
        const subtitle = this.dataset.subtitle?.trim();
        ends.textContent = subtitle || `${this.dataset.ends} ${weekday}`;
        this.title = `${this.dataset.ends} ${full}`;
        this.setAttribute('aria-label', `${this.dataset.saleName}. ${subtitle ? `${subtitle}. ` : ''}${this.title}`);
      } catch (_) {
        return;
      }
      this.refresh = () => this.tick();
      document.addEventListener('visibilitychange', this.refresh);
      window.addEventListener('pageshow', this.refresh);
      if (this.tick()) this.interval = setInterval(this.refresh, 1000);
    }

    tick() {
      const remaining = Math.ceil((this.deadline - Date.now()) / 1000);
      if (!Number.isFinite(remaining) || remaining <= 0) {
        this.hidden = true;
        clearInterval(this.interval);
        return false;
      }
      const values = [Math.floor(remaining / 86400), Math.floor(remaining % 86400 / 3600), Math.floor(remaining % 3600 / 60), remaining % 60];
      this.units.forEach((unit, index) => {
        const value = String(values[index]).padStart(2, '0');
        if (unit.textContent !== value) unit.textContent = value;
      });
      this.hidden = false;
      return true;
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
